module.exports = __webpack_public_path__ + "img/pos--avatar.8bda2c41.svg";